import React from 'react';
import { Link } from 'react-router-dom';

const headingFont = { fontFamily: "'Githera Regular', sans-serif" };
const bodyFont = { fontFamily: 'Roboto, sans-serif', fontWeight: 300 };

const base = process.env.PUBLIC_URL || '';

const columns = [
  {
    id: 'shipping',
    imageSrc: `${base}/ico-2024-009.png`,
    imageAlt: 'Free shipping',
    title: 'Free Shipping',
    to: '/shipping-policy',
  },
  {
    id: 'returns',
    imageSrc: `${base}/ico-2024-008.png`,
    imageAlt: 'Free returns and exchange',
    title: 'Free Returns and Exchange',
    to: '/shipping-policy',
  },
  {
    id: 'appointment',
    imageSrc: `${base}/ico-2024-010.png`,
    imageAlt: 'Book a private appointment in store',
    title: 'Book a Private Appointment in Store',
    to: '/about',
  },
];

/**
 * “At your service” strip — cream panel with three service pillars (above footer).
 */
export default function AtYourService() {
  return (
    <section
      className="w-full bg-[#f9f8f4] px-6 md:px-12 lg:px-24 py-14 md:py-20"
      aria-labelledby="at-your-service-heading"
    >
      <div className="max-w-[1200px] mx-auto">
        <h2
          id="at-your-service-heading"
          className="text-center text-[#1a1917] text-[1.65rem] md:text-[2rem] tracking-tight mb-12 md:mb-16 font-normal"
          style={headingFont}
        >
          At your service
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-0 md:divide-x md:divide-[#e3dfd6]">
          {columns.map((col) => (
            <div
              key={col.id}
              className="flex flex-col items-center text-center px-4 md:px-8 lg:px-10 pb-2 md:pb-0 border-b border-[#e3dfd6] md:border-b-0 last:border-b-0"
            >
              <div className="mb-6 flex h-[100px] w-[100px] md:h-[120px] md:w-[120px] items-center justify-center">
                <img
                  src={col.imageSrc}
                  alt={col.imageAlt}
                  className="max-h-full max-w-full object-contain opacity-[0.92]"
                  loading="lazy"
                  decoding="async"
                />
              </div>
              <h3
                className="text-[#1a1917] text-[1rem] lg:text-[18px] md:text-[1.05rem] leading-snug max-w-[16rem] md:max-w-none mb-5"
                style={bodyFont}
              >
                {col.title}
              </h3>
              <Link
                to={col.to}
                className="text-[#8b4d2f] text-[0.95rem] lg:text-[18px] md:text-[1rem] tracking-wide hover:opacity-80 transition-opacity"
                style={{ ...bodyFont, fontWeight: 400 }}
              >
                – Discover More –
              </Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
